/**
 * Helpers for the API's resource naming scheme (PRD §10.1).
 *
 * Resource names are stored in full: "users/{user}", "memos/{memo}",
 * "attachments/{attachment}". Only the final ID segment appears in URL paths.
 */

/** Return the final segment of a resource name ("memos/abc" -> "abc"). */
export function resourceId(name: string | undefined | null): string {
  if (!name) return "";
  const idx = name.lastIndexOf("/");
  return idx === -1 ? name : name.slice(idx + 1);
}

/** Return the collection of a resource name ("memos/abc" -> "memos"). */
export function resourceCollection(name: string | undefined | null): string {
  if (!name) return "";
  const idx = name.indexOf("/");
  return idx === -1 ? name : name.slice(0, idx);
}

export function memoName(id: string): string {
  return id.startsWith("memos/") ? id : `memos/${id}`;
}
export function userName(id: string): string {
  return id.startsWith("users/") ? id : `users/${id}`;
}
export function attachmentName(id: string): string {
  return id.startsWith("attachments/") ? id : `attachments/${id}`;
}

/** Username from a user resource name ("users/steven" -> "steven"). */
export function usernameFromName(name: string | undefined | null): string {
  return resourceId(name);
}

/** Join a field-mask list for the updateMask query param. */
export function updateMask(fields: string[]): string {
  return fields.join(",");
}
